function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrivateOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-21"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.92,
    y: 160.7,
    width: 176.29,
    height: 175.4,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.15,
    y: 168.84,
    width: 163.83,
    height: 47.74,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.15,
    y: 176.57,
    width: 9.31,
    height: 40.01,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.15,
    y: 176.57,
    width: 9.31,
    height: 40.01,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.7,
    y: 176.07,
    width: 9.31,
    height: 40.01,
    transform: "translate(-27.56 70) rotate(-9.78)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.68,
    y: 181.84,
    width: 9.31,
    height: 34.74,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.07,
    y: 181.84,
    width: 9.31,
    height: 34.74,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.07,
    y: 181.84,
    width: 9.31,
    height: 34.74,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.25,
    y: 181.24,
    width: 9.31,
    height: 34.74,
    transform: "translate(-34.58 82.14) rotate(-12.53)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.38,
    y: 174.58,
    width: 4.65,
    height: 41.99,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.74,
    y: 174.58,
    width: 4.65,
    height: 41.99,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.15,
    y: 224.13,
    width: 163.83,
    height: 47.74,
    transform: "translate(746.13 496) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.67,
    y: 231.86,
    width: 9.31,
    height: 40.01,
    transform: "translate(900.65 503.73) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.67,
    y: 231.86,
    width: 9.31,
    height: 40.01,
    transform: "translate(810.65 503.73) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.12,
    y: 231.36,
    width: 9.31,
    height: 40.01,
    transform: "translate(653.76 558.65) rotate(-170.22)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.14,
    y: 237.13,
    width: 9.31,
    height: 34.74,
    transform: "translate(877.59 509) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.75,
    y: 237.13,
    width: 9.31,
    height: 34.74,
    transform: "translate(834.81 509) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.76,
    y: 237.13,
    width: 9.31,
    height: 34.74,
    transform: "translate(726.82 509) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.57,
    y: 236.54,
    width: 9.31,
    height: 34.74,
    transform: "matrix(-0.98, -0.22, 0.22, -0.98, 714.11, 586.19)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.09,
    y: 229.87,
    width: 4.65,
    height: 41.99,
    transform: "translate(856.84 501.74) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.74,
    y: 229.87,
    width: 4.65,
    height: 41.99,
    transform: "translate(746.13 501.74) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.15,
    y: 231.86,
    width: 9.31,
    height: 40.01,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.68,
    y: 237.13,
    width: 9.31,
    height: 34.74,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.07,
    y: 237.13,
    width: 9.31,
    height: 34.74,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.38,
    y: 229.87,
    width: 4.65,
    height: 41.99,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.15,
    y: 279.43,
    width: 163.83,
    height: 47.74,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.18,
    y: 287.15,
    width: 9.31,
    height: 40.01,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.73,
    y: 286.66,
    width: 9.31,
    height: 40.01,
    transform: "translate(-45.63 79.93) rotate(-9.78)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.71,
    y: 292.43,
    width: 9.31,
    height: 34.74,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.11,
    y: 292.43,
    width: 9.31,
    height: 34.74,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.1,
    y: 292.43,
    width: 9.31,
    height: 34.74,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.28,
    y: 291.83,
    width: 9.31,
    height: 34.74,
    transform: "translate(-57.4 95.41) rotate(-12.53)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.41,
    y: 285.17,
    width: 4.65,
    height: 41.99,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.77,
    y: 285.17,
    width: 4.65,
    height: 41.99,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.67,
    y: 286.66,
    width: 9.31,
    height: 40.01,
    transform: "translate(-47.18 61.75) rotate(-9.78)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.03,
    y: 292.43,
    width: 9.31,
    height: 34.74,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.22,
    y: 291.83,
    width: 9.31,
    height: 34.74,
    transform: "translate(-59.95 72.19) rotate(-12.53)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.7,
    y: 285.17,
    width: 4.65,
    height: 41.99,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.48,
    y: 160.7,
    width: 176.29,
    height: 175.4,
    transform: "translate(251.25 496.8) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.71,
    y: 168.84,
    width: 163.83,
    height: 47.74,
    transform: "translate(251.25 385.41) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.23,
    y: 176.57,
    width: 9.31,
    height: 40.01,
    transform: "translate(405.77 393.14) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.23,
    y: 176.57,
    width: 9.31,
    height: 40.01,
    transform: "translate(315.77 393.14) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.68,
    y: 176.07,
    width: 9.31,
    height: 40.01,
    transform: "translate(171.87 406.84) rotate(-170.22)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.7,
    y: 181.84,
    width: 9.31,
    height: 34.74,
    transform: "translate(382.71 398.41) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.31,
    y: 181.84,
    width: 9.31,
    height: 34.74,
    transform: "translate(339.92 398.41) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.32,
    y: 181.84,
    width: 9.31,
    height: 34.74,
    transform: "translate(231.94 398.41) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.13,
    y: 181.24,
    width: 9.31,
    height: 34.74,
    transform: "translate(237.11 423.25) rotate(-167.47)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.65,
    y: 174.58,
    width: 4.65,
    height: 41.99,
    transform: "translate(361.96 391.15) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.3,
    y: 174.58,
    width: 4.65,
    height: 41.99,
    transform: "translate(251.25 391.15) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.71,
    y: 224.13,
    width: 163.83,
    height: 47.74,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.71,
    y: 231.86,
    width: 9.31,
    height: 40.01,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.71,
    y: 231.86,
    width: 9.31,
    height: 40.01,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.26,
    y: 231.36,
    width: 9.31,
    height: 40.01,
    transform: "matrix(0.99, -0.17, 0.17, 0.99, -40.54, 28.77)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.24,
    y: 237.13,
    width: 9.31,
    height: 34.74,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.63,
    y: 237.13,
    width: 9.31,
    height: 34.74,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.63,
    y: 237.13,
    width: 9.31,
    height: 34.74,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.81,
    y: 236.54,
    width: 9.31,
    height: 34.74,
    transform: "translate(-52.47 29.79) rotate(-12.53)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.94,
    y: 229.87,
    width: 4.65,
    height: 41.99,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.3,
    y: 229.87,
    width: 4.65,
    height: 41.99,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.23,
    y: 231.86,
    width: 9.31,
    height: 40.01,
    transform: "translate(405.77 503.73) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.7,
    y: 237.13,
    width: 9.31,
    height: 34.74,
    transform: "translate(382.71 509) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.31,
    y: 237.13,
    width: 9.31,
    height: 34.74,
    transform: "translate(339.92 509) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.65,
    y: 229.87,
    width: 4.65,
    height: 41.99,
    transform: "translate(361.96 501.74) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.71,
    y: 279.43,
    width: 163.83,
    height: 47.74,
    transform: "translate(251.25 606.59) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.2,
    y: 287.15,
    width: 9.31,
    height: 40.01,
    transform: "translate(217.71 614.32) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.65,
    y: 286.66,
    width: 9.31,
    height: 40.01,
    transform: "translate(55.73 618.09) rotate(-170.22)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.67,
    y: 292.43,
    width: 9.31,
    height: 34.74,
    transform: "translate(284.64 619.59) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.28,
    y: 292.43,
    width: 9.31,
    height: 34.74,
    transform: "translate(241.86 619.59) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.29,
    y: 292.43,
    width: 9.31,
    height: 34.74,
    transform: "translate(133.88 619.59) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.1,
    y: 291.83,
    width: 9.31,
    height: 34.74,
    transform: "translate(116.23 631.16) rotate(-167.47)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.62,
    y: 285.17,
    width: 4.65,
    height: 41.99,
    transform: "translate(263.9 612.33) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.27,
    y: 285.17,
    width: 4.65,
    height: 41.99,
    transform: "translate(153.19 612.33) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.72,
    y: 286.66,
    width: 9.31,
    height: 40.01,
    transform: "translate(268.31 636.27) rotate(-170.22)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.35,
    y: 292.43,
    width: 9.31,
    height: 34.74,
    transform: "translate(348.01 619.59) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.17,
    y: 291.83,
    width: 9.31,
    height: 34.74,
    transform: "translate(327.82 654.38) rotate(-167.47)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.33,
    y: 285.17,
    width: 4.65,
    height: 41.99,
    transform: "translate(367.32 612.33) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.04,
    cy: 98.42,
    r: 20.84,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.04,
    cy: 98.42,
    r: 17.52,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,99.42H252a1,1,0,0,1-.75-.44L244,88.23a1,1,0,1,1,1.66-1.12l6.54,9.7,4.56-5a1,1,0,1,1,1.47,1.35l-5.42,5.92A1,1,0,0,1,252,99.42Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-21"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-21",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-21"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "304 276.14 298.3 327.02 336.4 327.02 340.9 276.14 304 276.14",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304 276.14 298.3 327.02 331.97 327.02 336.47 276.14 304 276.14",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.47 276.14 331.97 327.02 336.4 327.02 340.9 276.14 336.47 276.14",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.65,286.46H294.09a3.26,3.26,0,0,1-3.26-3.41l3.6-75.1a3.25,3.25,0,0,1,3.25-3.1h59.88Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.61 204.85 348.7 286.46 353.65 286.46 357.56 204.85 352.61 204.85",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.15,208.34l-3.55,74.28a3.67,3.67,0,0,0,3.66,3.84h1.44l3.91-81.61h-1.79A3.68,3.68,0,0,0,347.15,208.34Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.24 328.84 293.71 344.41 295.83 414.84 302.83 414.84 304.94 344.41 305.41 328.84 293.24 328.84",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.24 328.84 293.71 344.41 295.83 414.84 302.83 414.84 304.94 344.41 305.41 328.84 293.24 328.84",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.24 328.84 293.71 344.84 304.94 344.84 305.41 328.84 293.24 328.84",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.22 414.59 261.69 329.94 272.26 329.94 263.21 414.59 255.22 414.59",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.23 414.59 255.23 414.59 261.1 337.54 261.69 329.84 272.26 329.84 271.44 337.54 263.23 414.59",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.26 329.84 271.44 337.84 261.1 337.84 261.69 329.84 272.26 329.84",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.45 414.59 326.39 329.94 336.96 329.94 343.43 414.59 335.45 414.59",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.43 414.59 327.21 337.54 326.4 329.84 336.97 329.84 337.55 337.54 343.42 414.59 335.43 414.59",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.4 329.84 327.21 337.84 337.55 337.84 336.97 329.84 326.4 329.84",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,321.18h86.6a0,0,0,0,1,0,0v6.69a5,5,0,0,1-5,5H261a5,5,0,0,1-5-5v-6.69A0,0,0,0,1,256,321.18Z",
    transform: "translate(598.65 654.04) rotate(-180)",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.88,
    y: 327.02,
    width: 94.9,
    height: 5.84,
    rx: 2.01,
    transform: "translate(598.65 659.89) rotate(180)",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.88,
    y: 327.02,
    width: 94.9,
    height: 5.84,
    rx: 2.01,
    transform: "translate(598.65 659.89) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.73,321.18H314.08L285.13,320l.46,1.92-22.4.18-1.15.32,1.15,10.44h25.93l-1.87-9.41C297.29,323.39,322.8,325.71,328.73,321.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.62,240.71s-28.39,6-30,6.26-9.2-2-10.66-1.79-3.85,7.06-4,8.59,11.91,2.66,13,2.24a20.65,20.65,0,0,0,3.31-2.21l29.69-3.13Z",
    style: {
      fill: "#e6ae76"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.05 201.96 309.28 202.75 305.73 206.92 325.81 206.48 325.05 201.96",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.44,227.6s-.28.76-.79,2-1.29,3.13-2.24,5.19c-2.3,5-5.64,11.36-9.13,14.79a9.4,9.4,0,0,1-3.1,2.16c-3.72,1.43-12.87,2.1-21.2,2s-15.63.68-15.63.68v-8.84l27.39-6.36s14.44-25.87,23-29.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.65,229.61c-.52,1.3-1.29,3.13-2.24,5.19-2.3,5-5.64,11.36-9.13,14.79-3.55-13.08,9.58-25.53,9.58-25.53Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.11 408.88 282.15 407.78 281.04 388.85 289 389.95 290.11 408.88",
    style: {
      fill: "#e6ae76"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289 389.95 281.04 388.86 281.68 399.68 289.62 400.38 289 389.95",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.79,297.56l1.95-12.18,44.66-2.67s4.75,25.34,1.1,32.09c-6.52,12.05-41.62,6-51.89,7.15,6.14,25.11,5.54,74.18,5.54,74.18l-14.67,1.12s-11.29-52.87-13.57-78C261.37,302.3,275.41,302.72,289.79,297.56Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.74 401.81 263.72 402.39 258.69 384.1 266.7 383.52 271.74 401.81",
    style: {
      fill: "#e6ae76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.63,402.67l-.13,0h0c0-.12-.4-2.36-1.38-2.9a.93.93,0,0,0-.8,0,.7.7,0,0,0-.49.73,3,3,0,0,0,1.19,1.63,3.24,3.24,0,0,0-2.25.06.7.7,0,0,0-.27.62,1,1,0,0,0,.5.95,2.1,2.1,0,0,0,1.56,0,9.42,9.42,0,0,0,2-.84.06.06,0,0,0,.07,0s0,0,0-.06A.11.11,0,0,0,262.63,402.67Zm-2.41-2.24c0-.11,0-.25.27-.36l.09,0a.55.55,0,0,1,.43.06c.58.31,1,1.52,1.17,2.26l-.18-.05C261.21,401.87,260.29,401,260.22,400.43Zm-1.05,2.93a.69.69,0,0,1-.31-.6.34.34,0,0,1,.14-.31c.45-.34,1.92-.05,3,.27C260.67,403.38,259.64,403.62,259.17,403.36Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.7 383.52 258.69 384.11 261.57 394.57 269.48 393.6 266.7 383.52",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,393.28l14.12-4.15s-8.43-47.58-17-64.08c.64-.21,1.49-.48,2.54-.79,1.89-.57,4.4-1.28,7.35-2.1,20.52-5.69,62.11-16.36,62.11-16.36l-19-17.73s-75.68,11.54-77.25,31.48C228.12,329.14,256,393.28,256,393.28Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.66,324.26c1.89-.57,4.58-1.33,7.53-2.15-.59-4.84-.78-10.34,1.55-13.17,4.63-5.64,16.54-8.95,23.32-10.15,5.67-1,24.72-3,24.72-3s-24.72-2.37-50,5C250.3,304.45,252.73,316.66,255.66,324.26Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.88,295.44c3-2.29.11-23.59,1.64-44.55,2.33-31.89,0-42.14-2.35-43.13a88.89,88.89,0,0,0-13.12-1.3,166.05,166.05,0,0,0-19.32.41,86,86,0,0,0-13,2.65s-10.52,33.49-3.8,81.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.88,295.44c3-2.29.11-23.59,1.64-44.55,2.33-31.89,0-42.14-2.35-43.13a88.89,88.89,0,0,0-13.12-1.3,166.05,166.05,0,0,0-19.32.41,86,86,0,0,0-13,2.65s-10.52,33.49-3.8,81.75Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.67,184.8c-1.09,6.24-2.06,17.65,2.38,21.71a20,20,0,0,1-14,6.35c-8,.35-5.31-5.94-5.31-5.94,6.9-1.8,6.61-6.94,5.3-11.75Z",
    style: {
      fill: "#e6ae76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.93,189,311,195.17a20.89,20.89,0,0,1,.67,3.42c2.64-.44,8.32-6.08,8.55-8.86C320.39,188.61,318.2,190.13,317.93,189Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.55,168.65c3.45,2.34,1.88,6.31-5.92,12.51-3.17-4.11-3.7-12.08-1.18-14.09S304.54,166.63,307.55,168.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.38,175.08c-.38,8.43-.17,13.37-4.34,17.77-6.29,6.6-16.74,2.93-18.9-5.44-1.92-7.52-1-20,7.19-23.53a11.51,11.51,0,0,1,16.05,11.2Z",
    style: {
      fill: "#e6ae76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.85,177.6c0,.69-.35,1.25-.8,1.25s-.81-.53-.82-1.22.34-1.24.78-1.26S309.79,176.93,309.85,177.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.06,177.74c0,.69-.35,1.25-.79,1.26s-.83-.54-.84-1.23.34-1.25.79-1.25S302.05,177.06,302.06,177.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.6,178a24.64,24.64,0,0,1-3.17,5.92,4,4,0,0,0,3.29.55Z",
    style: {
      fill: "#d08245"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.93,175.11a.4.4,0,0,0,.26-.06.41.41,0,0,0,.07-.57,4,4,0,0,0-3.3-1.6.38.38,0,0,0-.37.4v0a.43.43,0,0,0,.44.37h0a3.17,3.17,0,0,1,2.59,1.29A.41.41,0,0,0,311.93,175.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.47,175.18a.42.42,0,0,0,.36-.24,3.2,3.2,0,0,1,2.23-1.85.42.42,0,0,0,.35-.46.42.42,0,0,0-.45-.35,4,4,0,0,0-2.86,2.33.4.4,0,0,0,.19.53h0A.47.47,0,0,0,298.47,175.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.9,167.68c-3.92,1.41-3.36,5.65,2.68,13.57,4.08-3.21,6.55-10.83,4.59-13.38S322.31,166.45,318.9,167.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.5,181.75a8,8,0,0,1-3.73,4.86c-2.45,1.38-4.34-.65-4.22-3.31.1-2.39,1.51-6,4.23-6.29S327.17,179.23,326.5,181.75Z",
    style: {
      fill: "#e6ae76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,185.89s-1.46,2.76-5.54,2.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.526291px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.35,166.34s1.25,8.44,9.38,9S327.6,171,327.6,171a9.36,9.36,0,0,0,0-8.06c-1.87-3.7-11.83-2.55-16.56-3.45-20.11-5.33-20,.75-15.94,9,0,0-1.32,3.15,3.56,5.52C298.66,174,299.59,165.45,310.35,166.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.52,246.1s-29-.66-30.64-.83-8.5-4-10-4.2-5.38,6-5.86,7.44,11,5.33,12.1,5.17a20.69,20.69,0,0,0,3.73-1.39l29.61,3.81Z",
    style: {
      fill: "#e6ae76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.39,234.48s0,0,0,0c-4.31,7-10.34,14.45-16.35,14.1-6.29-.37,0-13.21,6.81-24.39a15.72,15.72,0,0,1,.67,1.57c1.53,4.28,6.2-1,8.58-7.88A149,149,0,0,1,341.39,234.48Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.93,401.58l8.68-2.42a.56.56,0,0,1,.72.36h0l2.34,6.76a1.42,1.42,0,0,1-1,1.75c-3,.79-4.54,1-8.37,2.06-2.35.65-6.92,2.15-10.27,2.53s-3.64-2.94-2.25-3.4c3.27-1.09,7.2-4.51,8.9-6.83A2.26,2.26,0,0,1,262.93,401.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.35,407.8h0c0-.14-.13-2.41-1-3.14a1.22,1.22,0,0,0-.89-.21.78.78,0,0,0-.68.61,2.8,2.8,0,0,0,.79,1.84,3.28,3.28,0,0,0-2.23-.41.68.68,0,0,0-.4.56,1,1,0,0,0,.29,1,2.21,2.21,0,0,0,1.53.3,10.61,10.61,0,0,0,2.09-.42H281s0,0,0-.06.2,0,.2-.08l.17,0Zm-2.21-2.67c0-.11.07-.24.34-.29h.09a.56.56,0,0,1,.41.14,4.17,4.17,0,0,1,.68,2.46l-.17-.09A3.78,3.78,0,0,1,279.14,405.13Zm-1.64,2.65a.65.65,0,0,1-.17-.65.34.34,0,0,1,.19-.28c.51-.23,1.89.35,2.86.89C279,408.11,277.9,408.13,277.5,407.78Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.55,406.82l9-.56a.56.56,0,0,1,.62.51h0l.89,7.1a1.42,1.42,0,0,1-1.31,1.5c-3.15.15-4.66.06-8.62.27-2.43.15-7.22.67-10.57.34s-2.95-3.63-1.5-3.79c3.44-.39,8-2.91,10.14-4.83A2.23,2.23,0,0,1,281.55,406.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.17,207.76a25.82,25.82,0,0,0-11.25,10.84c-4.58,8.08-12.53,25.2-15.88,26.05s-43.24-.87-43.24-.87l-1.57,10.27s44.57,7.49,52.66,3.35S353,213.1,338.17,207.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.73,206.92c-5.7,3.94-7.7,19.68-7.7,19.68-1,6.6-.79,8.63,3.4,9.45,10.46,2.4,15.2-2.81,16.1-8.1,0,0,3.2-17.39,8.29-21.47l-14.29,6.4Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.73,206.92c-5.7,3.94-7.7,19.68-7.7,19.68-1,6.6-.79,8.63,3.4,9.45,10.46,2.4,15.2-2.81,16.1-8.1,0,0,3.2-17.39,8.29-21.47l-14.29,6.4Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.73,206.92c-5.7,3.94-7.7,19.68-7.7,19.68-1,6.6-.79,8.63,3.4,9.45,10.46,2.4,15.2-2.81,16.1-8.1,0,0,3.2-17.39,8.29-21.47l-14.29,6.4Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.53 212.88 314.08 205.79 325.05 201.96 325.81 206.48 311.53 212.88",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.53 212.88 314.08 205.79 325.05 201.96 325.81 206.48 311.53 212.88",
    style: {
      fill: "#fff",
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.08 205.79 317.15 212.88 325.81 206.48 325.05 201.96 314.08 205.79",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.08 205.79 317.15 212.88 325.81 206.48 325.05 201.96 314.08 205.79",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.53 212.88 308.59 205.77 309.28 202.75 305.73 206.92 311.53 212.88",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.53 212.88 308.59 205.77 309.28 202.75 305.73 206.92 311.53 212.88",
    style: {
      fill: "#fff",
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.59 205.77 305.5 213.55 305.73 206.92 309.28 202.75 308.59 205.77",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.59 205.77 305.5 213.55 305.73 206.92 309.28 202.75 308.59 205.77",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-21"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.17,
    y: 215.01,
    width: 2.25,
    height: 18.58,
    transform: "translate(-44.07 32.24) rotate(-12.08)",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.17,
    y: 215.01,
    width: 2.25,
    height: 18.58,
    transform: "translate(-44.07 32.24) rotate(-12.08)",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.67,
    y: 213.21,
    width: 2.25,
    height: 18.58,
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.67,
    y: 213.21,
    width: 2.25,
    height: 18.58,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.1,
    y: 216.7,
    width: 2.25,
    height: 18.58,
    transform: "translate(76.31 -33.06) rotate(17.88)",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.1,
    y: 216.7,
    width: 2.25,
    height: 18.58,
    transform: "translate(76.31 -33.06) rotate(17.88)",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,231.8h15.78a0,0,0,0,1,0,0v21.13a3.17,3.17,0,0,1-3.17,3.17H132.2a3.17,3.17,0,0,1-3.17-3.17V231.8A0,0,0,0,1,129,231.8Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,231.8h15.78a0,0,0,0,1,0,0v21.13a3.17,3.17,0,0,1-3.17,3.17H132.2a3.17,3.17,0,0,1-3.17-3.17V231.8A0,0,0,0,1,129,231.8Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.86 362.64 349.29 365.57 349.29 368.42 352.66 369.62 357.16 369.17 356.19 365.72 350.86 362.64",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.86 362.64 349.29 365.57 349.29 368.42 352.66 369.62 357.16 369.17 356.19 365.72 350.86 362.64",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.11 365.34 352.36 366.13 352.36 368.72 351.76 367.03 350.71 367.44 351.24 366.54 350.11 365.34",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.01 366.13 355.65 366.13 356.71 368.72 355.36 367.03 354.01 366.13",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.28 371.75 341.9 369.24 344 365.53 348.5 364.48 351.05 366.5 350.6 371.75 345.28 371.75",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.28 371.75 341.9 369.24 344 365.53 348.5 364.48 351.05 366.5 350.6 371.75 345.28 371.75",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.58 369.06 345.5 368.12 348.35 369.06 350.15 371.38 347.38 369.62 345.43 370.18 345.43 368.75 342.58 369.06",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.9 366.13 346.48 367.33 348.13 367.33 349.7 366.73 347.3 366.73 344.9 366.13",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.77 363.75 356.29 367.27 358.77 371.1 360.94 370.57 363.87 370.65 365.07 367.42 360.68 363.75 358.77 363.75",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.77 363.75 356.29 367.27 358.77 371.1 360.94 370.57 363.87 370.65 365.07 367.42 360.68 363.75 358.77 363.75",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.12 366.95 359.74 366.95 359.07 370.27 358.92 367.8 357.12 366.95",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.44 369.9 360.68 366.95 364.24 367.8 362.34 368.25 363.19 369.9 361.39 367.8 360.44 369.9",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.43 365.66 359.74 364.87 361.39 365.66 363.12 366.95 359.74 365.66 358.43 365.66",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.77 365.08 362.73 371 366.17 371.75 370.97 370.78 373.37 367.56 371.12 362.68 364.15 362.15 360.77 365.08",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.77 365.08 362.73 371 366.17 371.75 370.97 370.78 373.37 367.56 371.12 362.68 364.15 362.15 360.77 365.08",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.31 369.76 365.4 367.39 368.27 367.51 368.66 369.9 367.76 368.35 365.72 368.15 363.31 369.76",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.1 367.25 371.72 366.83 372.9 367.39 371 370.26 372.23 367.68 371.53 367.39 369.1 367.25",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.17 368.35 361.37 365.29 363.85 363.74 368.66 364.92 364.37 364.47 362.36 365.65 363.17 368.35",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.99 362.78 370.41 363.18 372.17 366.05 370.09 363.74 365.99 362.78",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.36,370.8h34.55a0,0,0,0,1,0,0v40.65a4.67,4.67,0,0,1-4.67,4.67H345a4.67,4.67,0,0,1-4.67-4.67V370.8A0,0,0,0,1,340.36,370.8Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.36,370.8h34.55a0,0,0,0,1,0,0v40.65a4.67,4.67,0,0,1-4.67,4.67H345a4.67,4.67,0,0,1-4.67-4.67V370.8A0,0,0,0,1,340.36,370.8Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.13,368.64h33a1.27,1.27,0,0,1,1.27,1.27v1.37a0,0,0,0,1,0,0H339.86a0,0,0,0,1,0,0v-1.37A1.27,1.27,0,0,1,341.13,368.64Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.13,368.64h33a1.27,1.27,0,0,1,1.27,1.27v1.37a0,0,0,0,1,0,0H339.86a0,0,0,0,1,0,0v-1.37A1.27,1.27,0,0,1,341.13,368.64Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.31,
    y: 281.31,
    width: 12.45,
    height: 134.93,
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.31,
    y: 281.24,
    width: 6.46,
    height: 134.93,
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.82,
    y: 281.24,
    width: 6.46,
    height: 134.93,
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.02,
    y: 281.24,
    width: 6.46,
    height: 134.93,
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.91 416.13 386.45 416.13 386.45 281.27 283.55 281.27 283.55 416.13 271.74 416.13 271.74 281.27 98.45 281.27 98.45 416.13 92.53 416.13 92.53 256.1 392.91 256.1 392.91 416.13",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.91 416.13 386.45 416.13 386.45 281.27 283.55 281.27 283.55 416.13 277.16 416.13 277.16 263.95 392.91 263.95 392.91 416.13",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.16,
    y: 256.1,
    width: 115.75,
    height: 7.85,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.53,
    y: 256.1,
    width: 184.7,
    height: 7.85,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.24 416.13 271.56 415.99 271.74 281.27 98.45 281.27 98.45 416.13 92.53 416.13 92.53 263.95 277.24 263.95 277.24 416.13",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.02,
    y: 281.24,
    width: 6.46,
    height: 134.93,
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.82,
    y: 281.24,
    width: 6.46,
    height: 134.93,
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.48,252.1v2.64c0,.8,1.37,1.36,2.15,1.36h61.8c.79,0,2.05-.56,2.05-1.36V252.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.48,252.1v2.64c0,.8,1.37,1.36,2.15,1.36h61.8c.79,0,2.05-.56,2.05-1.36V252.1Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.48,252.1v2.64c0,.8,1.37,1.36,2.15,1.36h40.76c.79,0,2.09-.56,2.09-1.36V252.1Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.58,219.61l7.35,33.48a2.61,2.61,0,0,0,2.39,2H232.5a1.74,1.74,0,0,0,1.51-2.24l-7.34-33.12a2.3,2.3,0,0,0-2.39-1.64H184.09C183,218.1,182.34,218.52,182.58,219.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.58,219.61l7.35,33.48a2.61,2.61,0,0,0,2.39,2H232.5a1.74,1.74,0,0,0,1.51-2.24l-7.34-33.12a2.3,2.3,0,0,0-2.39-1.64H184.09C183,218.1,182.34,218.52,182.58,219.61Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.58,219.61l7.35,33.48a2.61,2.61,0,0,0,2.39,2h38.82a1.75,1.75,0,0,0,1.52-2.24l-7.36-33.12a2.3,2.3,0,0,0-2.39-1.64H184.09C183,218.1,182.34,218.52,182.58,219.61Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.21,241.07c-1.87,0-3.79-2-4.28-4.48s.64-4.49,2.52-4.49a2.91,2.91,0,0,1,1,.2,5.74,5.74,0,0,0,3.19,4.09,1.46,1.46,0,0,1,0,.2C209.22,239.06,208.09,241.07,206.21,241.07Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Speech-bubble-4--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.51,194.79l22.28,5.13a32.4,32.4,0,1,0,.66-7.85Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.51,194.79l22.28,5.13a32.4,32.4,0,1,0,.66-7.85Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.43,177a18.9,18.9,0,0,0-7.15,1.4,16.62,16.62,0,0,0-32.66,4.37c0,.34,0,.68.05,1h-.05a15.6,15.6,0,0,0-2.26,31V215h42.07a19,19,0,0,0,0-38Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.43,177a18.9,18.9,0,0,0-7.15,1.4,16.62,16.62,0,0,0-32.66,4.37c0,.34,0,.68.05,1h-.05a15.6,15.6,0,0,0-2.26,31V215h42.07a19,19,0,0,0,0-38Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.18 221.93 424.18 205.83 406.77 205.83 406.77 221.93 401.18 221.93 414.98 234.09 428.78 221.93 424.18 221.93",
    style: {
      fill: "#3E424F"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Speech-bubble-3--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.7,150.76l16.24-17.13a33.41,33.41,0,1,0-6.64-4.7Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.7,150.76l16.24-17.13a33.41,33.41,0,1,0-6.64-4.7Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.84 81.97 365.43 57.41 396.87 81.97 368.76 109.77 334.84 81.97",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.97,
    y: 68.7,
    width: 57.1,
    height: 33.74,
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.97,
    y: 68.7,
    width: 57.1,
    height: 33.74,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.34,
    y: 76.45,
    width: 44.85,
    height: 1.08,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.67,
    y: 79.69,
    width: 51.51,
    height: 1.26,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.67,
    y: 83.11,
    width: 51.51,
    height: 1.26,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.67,
    y: 86.35,
    width: 51.51,
    height: 1.26,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.67,
    y: 89.72,
    width: 51.51,
    height: 1.26,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.76,
    y: 92.66,
    width: 51.51,
    height: 1.26,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.76,
    y: 95.9,
    width: 51.51,
    height: 1.26,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.67,
    y: 98.42,
    width: 51.51,
    height: 1.26,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.87 118.35 334.84 118.35 334.84 81.97 365.85 102.5 396.87 81.97 396.87 118.35",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.87 118.35 334.84 118.35 334.84 81.97 365.85 102.5 396.87 81.97 396.87 118.35",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Speech-bubble-2--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.57,156.05l-9-24.41a36.78,36.78,0,1,0-7.89,4.26Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.57,156.05l-9-24.41a36.78,36.78,0,1,0-7.89,4.26Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.79,
    y: 65.1,
    width: 50.03,
    height: 64.58,
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.79,
    y: 68.54,
    width: 50.03,
    height: 61.14,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.57,72.63h-18a2.42,2.42,0,0,0-2.43,2.42v3.57a2.43,2.43,0,0,0,2.43,2.43h.64a4,4,0,0,1-3.07,2.68c2.31-.1,3.82-1,4.55-2.68h15.87A2.43,2.43,0,0,0,249,78.62V75.05A2.42,2.42,0,0,0,246.57,72.63Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,95.34H228.19a2,2,0,0,0-2,2v1.78a2,2,0,0,0,2,2h1.08a4,4,0,0,1-3.12,2.87c2.39-.11,3.92-1.07,4.62-2.87H247a2.05,2.05,0,0,0,2.05-2V97.39A2.05,2.05,0,0,0,247,95.34Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.39,105.94H252.67a2.08,2.08,0,0,0-2.08,2.07v1a2.08,2.08,0,0,0,2.08,2.07h7.53c.7,1.8,2.23,2.77,4.62,2.88a4,4,0,0,1-3.11-2.88h1.68a2.07,2.07,0,0,0,2.07-2.07v-1A2.07,2.07,0,0,0,263.39,105.94Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.42,82.58H237.77a2.05,2.05,0,0,0-2.05,2v4.73a2.05,2.05,0,0,0,2.05,2h22.36c.66,1.92,2.22,3,4.69,3.06a4,4,0,0,1-3.15-3.06h1.75a2,2,0,0,0,2-2V84.62A2,2,0,0,0,263.42,82.58Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.28,
    y: 121.72,
    width: 43.05,
    height: 4.42,
    rx: 1.8,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Speech-bubble-1--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.15,186.75l-23.38-9.06a35.44,35.44,0,1,0-1.94,8.42Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.15,186.75l-23.38-9.06a35.44,35.44,0,1,0-1.94,8.42Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.81,
    y: 183.56,
    width: 70.67,
    height: 1.54,
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.81,
    y: 183.56,
    width: 70.67,
    height: 1.54,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.34,
    y: 170.35,
    width: 7.99,
    height: 13.21,
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.34,
    y: 170.35,
    width: 7.99,
    height: 13.21,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.47,
    y: 162.98,
    width: 7.99,
    height: 20.59,
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.47,
    y: 162.98,
    width: 7.99,
    height: 20.59,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.22,
    y: 155.61,
    width: 7.99,
    height: 27.96,
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.22,
    y: 155.61,
    width: 7.99,
    height: 27.96,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.97,
    y: 148.54,
    width: 7.99,
    height: 35.03,
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.97,
    y: 148.54,
    width: 7.99,
    height: 35.03,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateOffice);
export default __webpack_public_path__ + "static/media/Private-Office.3f69e79120c5640028e71f83bb51996d.svg";
export { ForwardRef as ReactComponent };